import { configs } from '../../../../constants/configs/configs';
import { SIDENAV_LINKS_TYPES } from '../constants/sideNavLinkTypes';
import { ALL_USER_ROLES } from '../../../../constants/roles/userRoleTypes';
import { ENVIRONMENT_LINK_ENDPOINTS_NAMES } from '../../../../constants/common/environmentLinkEndpointNames';
import { ssapModalTypes as MODAL_TYPES } from '../../../../constants/ssap/modals/ssapModalTypes';
const {
    states : {
        IDAHO,
        MINNESOTA,
        NEVADA,
        PENNSYLVANIA,
        NEW_JERSEY,
        NEW_MEXICO,
        GEORGIA,
        VIRGINIA,
        GETINSURED
    },
    routes,
    endpoints,
    externalEndpoints,
} = configs;

export const navLinksNames = {
    DELEGATES: 'My Delegates',
    MY_ELIGIBILITY_HOME: 'My Eligibility Home',
    MY_HOUSEHOLDS: 'My Households',
    MY_TICKETS: 'tickets',
    MY_INBOX_JSP: 'inbox_jsp',
    MY_INBOX: 'inbox',
    PREFERENCES: 'preferences'
};

/* *
* ToDo - Add description for the keys
* section - specify the
* name - Text for Navigation
* icon -
* type - existing options are 'header', SIDENAV_LINKS_TYPES.LINK, modal
* path -
* */
export const navLinks = {
    [IDAHO]: [
        {
            sectionHeader: 'sidenav_header_my_stuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'sidenav_dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: 'applications',
                    text: 'sidenav_applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: true
                },
                {
                    name: 'eligibility_results',
                    text: 'sidenav_eligibility_results',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'sidenav_enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'sidenav_delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'sidenav_tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: 'preferences',
                    text: 'sidenav_preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: 'find__local__assistance',
                    text: 'sidenav_find_local_assistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visibility: true
                },
                {
                    name: 'download__appeals__form',
                    text: 'sidenav_download_appeals_form',
                    icon: 'download',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: externalEndpoints.ID_LINKS.DOWNLOAD_APPEALS_FORM,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'sidenav_header_accesscode',
            sectionItems: [
                {
                    name: 'access_code',
                    btnname: 'button.submit',
                    icon: '',
                    type: SIDENAV_LINKS_TYPES.INPUT_WITH_SUBMIT_BUTTON,
                    path: '',
                    visibility: true,
                    isDisabled: true
                }
            ]
        }
    ],
    [MINNESOTA]: [
        {
            sectionHeader: 'sidenav_header_my_stuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'sidenav_dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: 'eligibility__history',
                    text: 'sidenav_eligibility_history',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: true
                },
                {
                    name: 'eligibility_results',
                    text: 'sidenav_eligibility_results',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: navLinksNames.MY_HOUSEHOLDS,
                    text: 'sidenav_my_households',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.MULTI_HOUSEHOLD_DETAILS,
                    visibility: (multiHouseholdEnabled) => multiHouseholdEnabled
                },
                {
                    name: 'My Enrollments',
                    text: 'sidenav_enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'sidenav_delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'sidenav_tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: navLinksNames.MY_ELIGIBILITY_HOME,
                    text: 'sidenav_my_eligibility_home',
                    icon: 'home',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.MY_ELIGIBILITY_HOME,
                    visibility: (isIndividualUser) => isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                }
            ]
        }
    ],
    [NEVADA]: [
        {
            sectionHeader: 'sidenav_header_my_stuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'sidenav_dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: 'applications',
                    text: 'sidenav_applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: true
                },
                {
                    name: 'eligibility_results',
                    text: 'sidenav_eligibility_results',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'sidenav_enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'sidenav_delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'sidenav_tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: 'preferences',
                    text: 'sidenav_preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'sidenav_find_local_assistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visibility: true
                },
                {
                    name: 'user_guides',
                    text: 'sidenav_user_guides',
                    icon: 'folder-open',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: externalEndpoints.NV_LINKS.USER_GUIDES,
                    visibility: true,
                    blank: true
                }
            ]
        }
    ],
    [PENNSYLVANIA]: [
        {
            sectionHeader: 'sidenav_header_my_stuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'sidenav_dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: 'applications',
                    text: 'sidenav_applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: true
                },
                {
                    name: 'eligibility_results',
                    text: 'sidenav_eligibility_results',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'sidenav_enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'sidenav_delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'sidenav_tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: navLinksNames.PREFERENCES,
                    text: 'sidenav_preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'sidenav_find_local_assistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visibility: true
                }
            ]
        }
    ],
    [NEW_MEXICO]: [
        {
            sectionHeader: 'sidenav_header_my_stuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'sidenav_dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: 'applications',
                    text: 'sidenav_applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: true
                },
                {
                    name: 'eligibility_results',
                    text: 'sidenav_eligibility_results',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'sidenav_enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'sidenav_delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'sidenav_tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: navLinksNames.PREFERENCES,
                    text: 'sidenav_preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'sidenav_find_local_assistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visibility: true
                }
            ]
        }
    ],
    [GETINSURED]: [
        {
            sectionHeader: 'sidenav_header_my_stuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'sidenav_dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: 'applications',
                    text: 'sidenav_applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: true
                },
                {
                    name: 'eligibility_results',
                    text: 'sidenav_eligibility_results',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'sidenav_enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'sidenav_delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'sidenav_tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: navLinksNames.PREFERENCES,
                    text: 'sidenav_preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'sidenav_find_local_assistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visibility: true
                }
            ]
        }
    ],
    [NEW_JERSEY]: [
        {
            sectionHeader: 'sidenav_header_my_stuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'sidenav_dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: 'applications',
                    text: 'sidenav_applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: true
                },
                {
                    name: 'eligibility_results',
                    text: 'sidenav_eligibility_results',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'sidenav_enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'sidenav_delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'sidenav_tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: 'preferences',
                    text: 'sidenav_preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'sidenav_find_local_assistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visibility: true
                }
            ]
        }
    ],
    [GEORGIA]: [
        {
            sectionHeader: 'sidenav_header_my_stuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'sidenav_dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: 'applications',
                    text: 'sidenav_applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: true
                },
                {
                    name: 'eligibility_results',
                    text: 'sidenav_eligibility_results',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'sidenav_enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'sidenav_delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'sidenav_tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: 'preferences',
                    text: 'sidenav_preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: (preventConsumerPreferencePageAccess) => !preventConsumerPreferencePageAccess
                }
            ]
        },
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'sidenav_find_local_assistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    path: '#',
                    visibility: true
                }
            ]
        }
    ],
    [VIRGINIA]: [
        {
            sectionHeader: 'sidenav_header_my_stuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'sidenav_dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: 'applications',
                    text: 'sidenav_applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: true
                },
                {
                    name: 'eligibility_results',
                    text: 'sidenav_eligibility_results',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'sidenav_enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'sidenav_delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'sidenav_inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'sidenav_tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: navLinksNames.PREFERENCES,
                    text: 'sidenav_preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'sidenav_header_quick_links',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'sidenav_find_local_assistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    path: '#',
                    visibility: true
                }
            ]
        }
    ],
};